import React from 'react';
import { Star, Quote } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from './ui/card';

const Reviews = () => {
  const { t } = useTranslation();

  const reviews = [
    {
      authorKey: 'review1Author',
      dateKey: 'review1Date',
      textKey: 'review1Text',
      rating: 5
    },
    {
      authorKey: 'review2Author',
      dateKey: 'review2Date',
      textKey: 'review2Text',
      rating: 5
    },
    {
      authorKey: 'review3Author',
      dateKey: 'review3Date',
      textKey: 'review3Text',
      rating: 5
    },
    {
      authorKey: 'review4Author',
      dateKey: 'review4Date',
      textKey: 'review4Text',
      rating: 5
    }
  ];

  return (
    <section id="reviews" className="py-20 bg-gradient-to-br from-pink-50 to-purple-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('reviews.title')}
          </h2>
          <p className="text-xl text-gray-600 mb-6">
            {t('reviews.subtitle')}
          </p>
          
          {/* Google Rating */}
          <div className="inline-flex flex-col items-center gap-2 bg-white rounded-2xl px-8 py-4 shadow-lg">
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-8 h-8 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <p className="text-3xl font-bold text-gray-900">5.0</p>
            <p className="text-sm text-gray-600">{t('reviews.googleRating')}</p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {reviews.map((review, index) => (
            <Card 
              key={index}
              className="border-0 shadow-lg hover:shadow-xl transition-shadow bg-white"
            >
              <CardContent className="p-6">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-pink-200 to-purple-200 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-lg font-bold text-purple-700">
                      {t(`reviews.${review.authorKey}`).charAt(0)}
                    </span>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-900">{t(`reviews.${review.authorKey}`)}</h3>
                    <div className="flex items-center gap-2 mt-1">
                      <div className="flex gap-0.5">
                        {[...Array(review.rating)].map((_, i) => (
                          <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                        ))}
                      </div>
                      <span className="text-xs text-gray-500">{t(`reviews.${review.dateKey}`)}</span>
                    </div>
                  </div>
                  <Quote className="w-8 h-8 text-pink-200" />
                </div>
                
                <p className="text-gray-700 leading-relaxed">
                  {t(`reviews.${review.textKey}`)}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA to leave review */}
        <div className="text-center mt-12">
          <Card className="inline-block border-0 shadow-lg bg-white">
            <CardContent className="p-6">
              <p className="text-gray-700 mb-4">
                {t('reviews.ctaText')}
              </p>
              <a 
                href="https://www.google.com/search?q=4+kids+asilo+nido+pesaro" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#E91E8C] hover:bg-[#d01a7a] text-white px-6 py-3 rounded-full font-semibold transition-colors shadow-md hover:shadow-lg"
              >
                <Star className="w-5 h-5" />
                {t('reviews.ctaButton')}
              </a>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
